export default __webpack_public_path__ + "static/media/pic3.133e7246.jpg";